module.exports = __webpack_public_path__ + "static/media/14CarmelPiano.a00101e8.jpg";